import config from '../config/config';

const getViewPdfLink = (type, slug, shortLink) => (shortLink
  ? `${config.shortLinkDomain}${shortLink}`
  : `${process.env.APP_DOMAIN}/view/${getRoute(type || 'SUPPLEMENT')}/${slug}`);
const getRoute = type => `${type.toLowerCase()}s`;
export default getViewPdfLink;
